import React, { useContext, useEffect } from "react";
import DefaultDashboardPanelComponent from "./defaultDashboardPanel.page";
import { useSelector } from "react-redux";
import { DashboardContext } from "modules/dashboard/pages/dashboard/dashboard.container";
import { useState } from "react";

function DefaultDashboardPanelContainer({ isCollapsible }) {
  const lang = useSelector((state) => state.constant.languages);
  const { currentFilter, activeIndex, showPopup, closePopup, popupIsShow } =
    useContext(DashboardContext);
  const defaultLocation = useSelector((state) => state.account.defaultLocation);
  const [defaultGeoLocation, setDefaultGeoLocation] = useState();

  useEffect(() => {
    setDefaultGeoLocation({
      lat: defaultLocation.latitude,
      lng: defaultLocation.longitude,
    });
  }, [defaultLocation]);

  return (
    <DefaultDashboardPanelComponent
      currentFilter={currentFilter}
      lang={lang}
      activeIndex={activeIndex}
      showPopup={showPopup}
      closePopup={closePopup}
      popupIsShow={popupIsShow}
      isCollapsible={isCollapsible}
      defaultGeoLocation={defaultGeoLocation}
    />
  );
}

export default DefaultDashboardPanelContainer;
